import { ApiNamespaces, IQueuedRequest, OneAPIOptions } from '../../common'
import { AppInvoicesApi } from './app'
import { BackofficeInvoicesApi } from './backoffice'
import { Queue } from '../../queue'

export class Invoices implements ApiNamespaces {
  app: AppInvoicesApi
  backoffice: BackofficeInvoicesApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppInvoicesApi(name, sessionId, requestsQueue, options)
    this.backoffice = new BackofficeInvoicesApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.app.invalidateAll()
    this.backoffice.invalidateAll()
  }
}
